module.exports = __webpack_public_path__ + "static/media/panel.icons.58b2c86c.png";